export { Reviews, mapTheatricalReleaseCriticToRating } from './Reviews'
